import { Tab, Tabs } from '@vapor/material'
import { useTranslation } from 'react-i18next'

export default function CustomerTabs({ value, onChange }: { value: number; onChange: (value: number) => void; disabled: boolean }) {
  const { t } = useTranslation()
  return (
    <Tabs
      {...{ size: 'small', textColor: 'secondary' }}
      value={value}
      onChange={(_, newValue) => {
        onChange(newValue)
      }}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
    >
      <Tab label={t('pms.common.customer.generic_data_subtitle')} iconPosition="end" sx={{ minHeight: '48px' }} />
      <Tab label={t('pms.common.customer.customer_history')} sx={{ minHeight: '48px' }} />
    </Tabs>
  )
}
